import React, { useState, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import styles from './styles.module.scss';
import './datepickerCustomStyle.scss';
import useTranslation from 'hooks/useTranslation';
import { Button, AppDatePicker } from 'components';
import { postUserVisitsData } from 'redux/userVisitsArchive/userVisitsArchive.actions';
import moment from 'jalali-moment';
import { isValidEmail, getNotifMsg } from 'utils';
import { toast } from 'react-toastify';

const phoneNumberValidation = (phoneNumber) => {
  const regEx = /^\d{11}$/;

  if (regEx.test(phoneNumber)) {
    return true;
  }

  if (!regEx.test(phoneNumber) && phoneNumber !== '') {
    return false;
  }
};

const mapState = ({ appData, userVisitsData, websitesData }) => ({
  locale: appData.locale,
  isFetching: userVisitsData.isFetching,
  selectedWorkspace: websitesData.selectedWorkspace?.id,
});

const FilterBar = ({
  onChangeFilterField,
  date,
  email,
  phone,
  hadConversation,
  pageSize,
}) => {
  const [hasFormError, setHasFormError] = useState(false);

  const { getTranslation } = useTranslation('ARCHIVE');
  const { t } = getTranslation();

  const dispatch = useDispatch();
  const { isFetching, locale, selectedWorkspace } = useSelector(mapState);

  const checkList = {
    id: 'user_had_conversation',
    name: 'user_had_conversation',
    label: t('USER_VISITS_FILTER_3'),
  };

  const onSubmitFilter = () => {
    const firstDate = moment(new Date(date[0])).format(`YYYY-MM-DD`);
    const secondDate = date[1]
      ? moment(new Date(date[1])).format(`YYYY-MM-DD`)
      : firstDate;

    const data = {
      channelId: selectedWorkspace,
      skip: 1,
      limit: pageSize,
      filter: {
        startDate: new Date(`${firstDate}T00:00:00`).toISOString(),
        endDate: new Date(`${secondDate}T00:00:00`).toISOString(),
        email: '',
        phone: '',
        hadConversation: hadConversation ? 1 : 0,
      },
    };

    if (email && !isValidEmail(email)) {
      setHasFormError(true);
      return;
    }

    if (phone && !phoneNumberValidation(phone)) {
      setHasFormError(true);
      return;
    }

    data.filter.email = email;
    data.filter.phone = phone;

    if (selectedWorkspace) {
      setHasFormError(false);

      dispatch(postUserVisitsData(data));
      return;
    }
    toast.error(getNotifMsg('REQUEST_ADD_FILTER_CHANNEL_ID_FAILURE', locale));
  };

  const renderDateRangeFilterOptions = (
    <div className={styles.date_filter}>
      <div className={styles.filter_option}>
        <span className={styles.label}>{t('USER_VISITS_DATE_FROM_LABEL')}</span>
        <AppDatePicker
          selectedDate={date}
          setSelectedDate={(value) => onChangeFilterField('date', value)}
          renderSideMenu={false}
          monthsDisplay={1}
          className={styles.date_picker__wrapper}
        />
      </div>
    </div>
  );

  const renderPhoneNumberField = (
    <div className={styles.filter_option}>
      <span className={styles.label}>{t('USER_VISITS_FILTER_1')}</span>
      <div className={styles.select_phone_number_wrapper}>
        {hasFormError && !phoneNumberValidation(phone) && phone && (
          <span
            className={`${styles.error_message} ${
              hasFormError ? styles.visible : ''
            }`}
          >
            {t('USER_VISITS_IN_VALID_PHONE')}
          </span>
        )}
        <input
          type='number'
          className={`${styles.phone_number_input} ${
            hasFormError && !phoneNumberValidation(phone) && phone
              ? styles.error_input
              : ''
          }`}
          onChange={(e) => onChangeFilterField('phone', e.target.value)}
          value={phone}
        />
      </div>
    </div>
  );

  const renderEmailField = (
    <div className={styles.filter_option}>
      <span className={styles.label}>{t('EMAIL_FILTER_LABEL')}</span>
      <div className={styles.select_email_wrapper}>
        {hasFormError && !isValidEmail(email) && email && (
          <span
            className={`${styles.error_message} ${
              hasFormError ? styles.visible : ''
            }`}
          >
            {t('USER_VISITS_IN_VALID_EMAIL')}
          </span>
        )}
        <input
          type='email'
          className={`${styles.text_input} ${
            hasFormError && !isValidEmail(email) && email
              ? styles.error_input
              : ''
          }`}
          onChange={(e) => onChangeFilterField('email', e.target.value)}
          value={email}
        />
      </div>
    </div>
  );

  const renderHadConversationCheckBox = (
    <div className={styles.user_had_conversation}>
      <input
        name={checkList.name}
        onChange={(e) =>
          onChangeFilterField('hadConversation', e.target.checked)
        }
        type='checkbox'
        id={checkList.id}
        checked={hadConversation}
      />
      <label htmlFor={checkList.id}>{checkList.label}</label>
    </div>
  );

  return (
    <div className={styles.filter_bar_container}>
      <div
        className={`${styles.filter_bar_first_row} conversations_archive_filter_bar`}
      >
        {renderDateRangeFilterOptions}
        {renderPhoneNumberField}
        {renderEmailField}
        {renderHadConversationCheckBox}
      </div>

      <div className={styles.filter_bar_second_row}>
        <Button
          isLoading={isFetching}
          onClick={onSubmitFilter}
          className={styles.filter_bar__submit_btn}
        >
          {t('FILTER_SUBMIT_BTN_LABEL')}
        </Button>
      </div>
    </div>
  );
};

export default memo(FilterBar);
